/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccessRule model module.
 * @module model/AccessRule
 * @version 0.0.1
 */
class AccessRule {
    /**
     * Constructs a new <code>AccessRule</code>.
     * @alias module:model/AccessRule
     */
    constructor() { 
        
        AccessRule.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccessRule</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccessRule} obj Optional instance to populate.
     * @return {module:model/AccessRule} The populated <code>AccessRule</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccessRule();

            if (data.hasOwnProperty('uuid')) {
                obj['uuid'] = ApiClient.convertToType(data['uuid'], 'String');
            }
            if (data.hasOwnProperty('rule_type')) {
                obj['rule_type'] = ApiClient.convertToType(data['rule_type'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('access_machine_dealer')) {
                obj['access_machine_dealer'] = ApiClient.convertToType(data['access_machine_dealer'], 'String');
            }
            if (data.hasOwnProperty('access_machine_serial')) {
                obj['access_machine_serial'] = ApiClient.convertToType(data['access_machine_serial'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccessRule</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccessRule</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['uuid'] && !(typeof data['uuid'] === 'string' || data['uuid'] instanceof String)) {
            throw new Error("Expected the field `uuid` to be a primitive type in the JSON string but got " + data['uuid']);
        }
        // ensure the json data is a string
        if (data['rule_type'] && !(typeof data['rule_type'] === 'string' || data['rule_type'] instanceof String)) {
            throw new Error("Expected the field `rule_type` to be a primitive type in the JSON string but got " + data['rule_type']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['access_machine_dealer'] && !(typeof data['access_machine_dealer'] === 'string' || data['access_machine_dealer'] instanceof String)) {
            throw new Error("Expected the field `access_machine_dealer` to be a primitive type in the JSON string but got " + data['access_machine_dealer']);
        }
        // ensure the json data is a string
        if (data['access_machine_serial'] && !(typeof data['access_machine_serial'] === 'string' || data['access_machine_serial'] instanceof String)) {
            throw new Error("Expected the field `access_machine_serial` to be a primitive type in the JSON string but got " + data['access_machine_serial']);
        }

        return true;
    }


}



/**
 * @member {String} uuid
 */
AccessRule.prototype['uuid'] = undefined;

/**
 * @member {String} rule_type
 */
AccessRule.prototype['rule_type'] = undefined;

/**
 * @member {String} email
 */
AccessRule.prototype['email'] = undefined;

/**
 * @member {String} access_machine_dealer
 */
AccessRule.prototype['access_machine_dealer'] = undefined;

/**
 * @member {String} access_machine_serial
 */
AccessRule.prototype['access_machine_serial'] = undefined;






export default AccessRule;

